const parseRowDate = (value) => {
  if (!value) return null;
  const raw = String(value).trim();
  if (/^\d{4}[/-]\d{2}[/-]\d{2}/.test(raw)) {
    const [year, month, day] = raw.split("T")[0].split(/[/-]/);
    return new Date(Number(year), Number(month) - 1, Number(day));
  }
  if (/^\d{2}[/-]\d{2}[/-]\d{4}/.test(raw)) {
    const [day, month, year] = raw.split("T")[0].split(/[/-]/);
    return new Date(Number(year), Number(month) - 1, Number(day));
  }
  const normalized = new Date(raw);
  return Number.isNaN(normalized.getTime()) ? null : normalized;
};

const formatDateForDisplay = (value) => {
  const date = parseRowDate(value);
  if (!date) return value || "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const formatCurrencyBRL = (value = 0) => {
  const resolved = Number(value) || 0;
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(resolved);
};

const formatNumberComma = (value = 0, decimals = 2) => {
  const resolved = Number(value) || 0;
  return resolved.toFixed(decimals).replace(".", ",");
};

const formatBOB = (value) => `${formatNumberComma(value, 2)} Bs`;

const formatUSDTQuant = (value) => `${formatNumberComma(value, 8)}`;
const formatUSDTPrice = (value) =>
  value === null || value === undefined ? "—" : formatNumberComma(value, 4);

export const IN1888_COLUMNS = [
  { key: "ordem", label: "Ordem" },
  { key: "data", label: "Data" },
  { key: "nomeBrl", label: "Nome BRL" },
  { key: "nomeBob", label: "Nome BOB" },
  { key: "valorBrl", label: "Valor BRL", align: "right" },
  { key: "valorBob", label: "Valor BOB", align: "right" },
  { key: "usdtQuant", label: "USDT Quant", align: "right" },
  { key: "usdtPreco", label: "USDT Preço", align: "right" },
];

export const normalizeVenda = (row = {}) => ({
  ordem: "Venda",
  data: formatDateForDisplay(row.data ?? row.DATA ?? ""),
  nomeBrl: row.nomeBrl ?? row.NOMEBRL ?? "—",
  nomeBob: row.nomeBob ?? row.NOMEBOB ?? "—",
  valorBrl: formatCurrencyBRL(row.valorBrl ?? row.VALORBRL ?? 0),
  valorBob: formatBOB(row.valorBob ?? row.VALORBOB ?? 0),
  usdtQuant:
    row.usdtPriceSrc || row.USDT_PRICE_SRC
      ? formatUSDTQuant(row.usdtQuant ?? row.USDT_QUANT ?? 0)
      : "—",
  usdtPreco:
    row.usdtPriceSrc || row.USDT_PRICE_SRC
      ? formatUSDTPrice(row.usdtPreco ?? row.USDT_PRECO_UN ?? null)
      : "—",
});

export const normalizeCompra = (row = {}) => ({
  ordem: "Compra",
  data: formatDateForDisplay(row.data ?? row.DATA ?? ""),
  nomeBrl: row.nomeBrl ?? row.NOMEBRL ?? "—",
  nomeBob: row.nomeBob ?? row.NOMEBOB ?? "—",
  valorBrl: formatCurrencyBRL(row.valorBrl ?? row.VALORBRL ?? 0),
  valorBob: formatBOB(row.valorBob ?? row.VALORBOB ?? 0),
  usdtQuant:
    row.usdtQuant === null || row.usdtQuant === undefined
      ? "—"
      : formatUSDTQuant(row.usdtQuant),
  usdtPreco:
    row.usdtPreco === null || row.usdtPreco === undefined
      ? "—"
      : formatUSDTPrice(row.usdtPreco),
});
